<template>
  <div>
    <PendingUserForms :title="$t('table.pendingForms')" :items="pendingForms" :loading="loading"/>
      <HistoricUserForms class="mt-4"/>
  </div>
</template>

<script>
import HistoricUserForms from "../components/forms/HistoricUserForms";
import PendingUserForms from "../components/forms/PendingUserForms";
import axios from "axios";
export default {
    components: {PendingUserForms, HistoricUserForms},
  data: () => ({
    pendingForms: [],
    loading: true,
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/user/moderatedOperations/pending";
      axios
              .get(path)
              .then(response => {
                this.pendingForms = response.data;
                this.loading = false;
              })
              .catch(error => {
                console.log(error);
              });
    },
  },

};
</script>
